import React from "react";
import FlightDetails from "./FlightDetails";
import HotelDetails from "./HotelDetails";
import TransferDetails from "./TransferDetails";
import ActivityDetails from "./ActivityDetails";
import ItenaryDetails from './ItenaryDescription';

const DetailsContent = ({ ItineraryDetails, resourceKeys }) => {
    
  return (
    <div className="col-lg-12">
      {ItineraryDetails?.DayInfo?.map((dayInfo, dayIndex) => (
        <div key={dayIndex} className="day-details-section">
          {/* Day Itinerary */}
          {dayInfo?.DayNo && (
            <ItenaryDetails dayInfo={dayInfo} resourceKeys={resourceKeys} />
          )}

          {/* Flight Details */}
          {dayInfo?.FlightItems?.map((flightItem, flightIndex) => (
            <FlightDetails
              key={`flight-${dayIndex}-${flightIndex}`}
              flightItem={flightItem}
              resourceKeys={resourceKeys}
            />
          ))}

          {/* Hotel Details */}
          {dayInfo?.HotelItems?.map((hotelItem, hotelIndex) => (
            <HotelDetails
              key={`hotel-${dayIndex}-${hotelIndex}`}
              hotelItem={hotelItem}
              resourceKeys = {resourceKeys}
            />
          ))}

          {/* Transfer Details */}
          {dayInfo?.TransferItems?.map((transferItem, transferIndex) => (
            <TransferDetails
              key={`transfer-${dayIndex}-${transferIndex}`}
              transferItem={transferItem}
              resourceKeys = {resourceKeys}
            />
          ))}

          {/* Activity Details */}
          {dayInfo?.Activityitems?.map((activityItem, activityIndex) => (
            <ActivityDetails
              key={`activity-${dayIndex}-${activityIndex}`}
              activityItem={activityItem}
              resourceKeys = {resourceKeys}
            />
          ))}
        </div>
      ))}
    </div>
  );
};

export default DetailsContent;
